import type { SnapKind } from "../../snap/SnapEngine";
import type { PlanarGraph, SegmentPickTarget, SegmentSpec, XzPoint } from "./types";

export const SEGMENT_POINTER_CHANGED_EVENT = "segment-pointer-changed";
export const SEGMENT_SELECTION_CHANGED_EVENT = "segment-selection-changed";
export const SEGMENT_DRAFT_DIMENSION_EVENT = "segment-draft-dimension";
export const PLANAR_GRAPH_CHANGED_EVENT = "planar-graph-changed";

export interface SegmentPointerDetail {
  raw: XzPoint;
  snapped: XzPoint;
  snappedKinds: SnapKind[];
  /** Draft başlangıcı — angle snap align guide için. */
  snapAnchor?: XzPoint;
  /** Duvar doğrultu snap guide çizgisi (XZ yön). */
  snapGuideDir?: XzPoint;
  pickTarget: SegmentPickTarget | undefined;
  /** Ortak target behavior tarafından çözülen cursor. */
  cursor?: string;
  /** canvas üzerinde aktif; dışarıda veya mod kapalı false */
  active: boolean;
  planarGraph: PlanarGraph;
}

export interface SegmentSelectionDetail {
  selectedTarget: SegmentPickTarget | undefined;
  planarGraph: PlanarGraph;
}

export interface SegmentDraftDimensionDetail {
  spec: SegmentSpec | null;
  /** Opening ölçüleri için host duvar (sol/sağ kalan). */
  hostSpec?: SegmentSpec;
  focus?: boolean;
  editable?: boolean;
  onLengthMm?: (mm: number) => void;
}
